//Global Imports
import React from "react";
import moment from "moment";
//End Global Imports

//Local Imports
import { IForgotPassword } from "./ForgotPassword";
import { forgotPassword, getRequestTime, sendOtp, validateOtp } from "../../../services/auth";
import StepThree from "./StepThree";
import StepOne from "./StepOne";
import OtpPhase from "../OtpPhase";
import ForgotPasswordModal from "../../../components/ui/ForgotPasswordModal";
import { ForgotPasswordSuccessBanner } from "../../../assets/Icons";
import Modal from "../../../components/ui/Modal";
//End Local Imports

const ForgotPassword: React.FC<IForgotPassword.IProps> = ({
  isForgotPassword,
  setIsForgotPassword,
}) => {
  const [email, saveEmail] = React.useState<string>("");
  const [step, setStep] = React.useState<number>(1);
  const [otpValue, setOtpValue] = React.useState<string>("");
  const [otpError, setOTPError] = React.useState<boolean>(false);
  const [isOTPVerified, setOTPVerified] = React.useState<boolean>(false);
  const [verifyOtpError, setVerifyOtpError] = React.useState<string>("");
  const [date, saveDate] = React.useState(Date.now() + 120000);
  const [dateKey, saveDateKey] = React.useState<number>(0);
  const [error, setError] = React.useState<string>("");

  const goBackHandler = () => {
    setStep(1);
    setOtpValue("");
    setOTPError(false);
    setOTPVerified(false);
    setVerifyOtpError("");
    saveDateKey(0);
    setError("");
    setIsForgotPassword(false);
  };

  const registerEmail = (data: any) => {
    saveEmail(data.email);

    sendOtp({
      body: { email: data.email, otpType: "email" },
      apiType: "send",
    })
      .then(() => {
        setStep(2);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const verifyOTP = () => {
    getRequestTime().then((response: any) => {
      const reqTime = response.data.currentTime;

      validateOtp({
        email_phone: email,
        otp: otpValue,
        otpType: "email",
      })
        .then((response: any) => {
          const responseTime = response?.data?.timeStamp;
          const timeStampDiff = moment(responseTime, "hh:mm:ss").diff(
            moment(reqTime, "hh:mm:ss"),
            "seconds",
          );
          if (response?.data?.success && timeStampDiff <= 10) {
            setOTPError(false);
            setOTPVerified(true);
            setTimeout(() => {
              setVerifyOtpError("");
              setOTPVerified(false);
              setStep(3);
            }, 1000);
          } else if (response?.data?.is_invalid) {
            setOTPError(true);
            setOTPVerified(false);
            setVerifyOtpError(response?.data?.message);
          } else {
            setOTPError(true);
            setOTPVerified(false);
            setVerifyOtpError(response?.response?.data?.error?.type);
          }
        })
        .catch((error) => {
          setOTPError(true);
          setOTPVerified(false);
          setVerifyOtpError(error?.response?.data?.error?.type);
        });
    });
  };

  const resendOTP = () => {
    sendOtp({
      body: {
        email: email,
        otpType: "email",
      },
      apiType: "resend",
    })
      .then(() => {
        setOtpValue("");
        saveDate(Date.now() + 120000);
        saveDateKey(dateKey + 1);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const saveNewPassword = (data: any) => {
    getRequestTime().then((response: any) => {
      const reqTime = response.data.currentTime;

      forgotPassword({
        email: email,
        otp: otpValue,
        newPassword: data.password,
        confirmPassword: data.confirmPassword,
      })
        .then((response) => {
          const responseTime = response?.data?.timeStamp;

          const timeStampDiff = moment(responseTime, "hh:mm:ss").diff(
            moment(reqTime, "hh:mm:ss"),
            "seconds",
          );
          if (response?.data?.success && timeStampDiff <= 10) {
            setIsForgotPassword(false);
            setStep(4);
          } else {
            setError(response?.data?.message);
          }
        })
        .catch((error) => {
          setError(error.response.data.error.type);
          setTimeout(() => {
            setStep(1);
            setError("");
          }, 2000);
        });
    });
  };

  return (
    <>
      <ForgotPasswordModal
        visible={isForgotPassword}
        closeHandler={() => {
          setVerifyOtpError("");
          setOTPVerified(false);
          setIsForgotPassword(false);
          setStep(1);
        }}
      >
        <div className="flex flex-col items-center justify-between bg-opacity-100 mt-[88px]">
          {step === 1 && (
            <div className={"flex flex-col sm:items-center px-3"}>
              <StepOne registerEmail={registerEmail} />
            </div>
          )}
          {step === 2 && (
            <div className={"flex w-screen sm:w-max justify-center mx-[60px]"}>
              <OtpPhase
                title="Enter OTP sent to your email"
                otpValue={otpValue && otpValue}
                setOtpValue={setOtpValue}
                otpError={otpError && otpError}
                verifyOTP={verifyOTP}
                email={email && email}
                isOTPVerified={isOTPVerified && isOTPVerified}
                verifyOtpError={verifyOtpError && verifyOtpError}
                resendOTP={resendOTP}
                dateKey={dateKey && dateKey}
                date={date && date}
                buttonText="Verify"
              />
            </div>
          )}
          {step === 3 && (
            <div>
              <StepThree saveNewPassword={saveNewPassword} />
            </div>
          )}

          {error !== "" && <div className="mt-4 text-sm text-error">{error}</div>}
          <div
            className="mt-6 text-lg font-bold cursor-pointer sm:flex pb-7 text-primary-1000 font-ssp"
            onClick={() => goBackHandler()}
          >
            Go back to login
          </div>
        </div>
      </ForgotPasswordModal>
      <Modal visible={step === 4} closeHandler={() => setIsForgotPassword(false)} closable={false}>
        <div className="flex flex-col items-center justify-between bg-opacity-100">
          {step === 4 && (
            <div className="flex flex-col items-center justify-center md:pb-20 pb-9 lg:mx-[530px]">
              <div className="md:pb-[60px] pb-10">
                <ForgotPasswordSuccessBanner />
              </div>
              <div className="w-full mb-2 text-2xl font-bold text-center text-black">
                Congratulations!
              </div>
              <div className="w-full text-2xl font-normal text-center text-black lg:w-[54%]">
                Your password has been successfully updated
              </div>
            </div>
          )}
          <div
            className="mt-6 text-lg font-bold cursor-pointer sm:flex pb-7 text-primary-1000 font-ssp"
            onClick={() => goBackHandler()}
          >
            Go back to login
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ForgotPassword;